<template>
    <div class="w-full space-y-4">
        <div
            v-for="bike in cart.bikes"
            :key="bike"
            class="grid grid-cols-2 lg:grid-cols-6 gap-4 items-center border-b pb-4"
        >
            <div class="col-span-2">
                <p class="font-bold text-center">
                    {{ bike.brand + ' ' + bike.model }}
                </p>

                <div class="aspect-[1.777] max-w-xs">
                    <img
                        class="remove_bg_color w-full"
                        :src="
                            $apiUrl() +
                            '/storage/assets/images/bikes_pictures/' +
                            bike.id +
                            '/A.jpg'
                        "
                        @error="
                            e =>
                                (e.target.src =
                                    '/storage/assets/images/default.png')
                        "
                    />
                </div>
            </div>
            <div>
                <label>Taille :</label>
                <AppSelect
                    v-model="bike.selected_size"
                    :options="
                        bike.sizes.map(size => ({
                            label:
                                size +
                                (bike.stocks[size] ? '' : ' - Not Available'),
                            value: size,
                            disabled: !bike.stocks[size],
                        }))
                    "
                    optionLabel="label"
                    optionValue="value"
                    :disabled="false"
                    @change="updateCart(bike, 'bike')"
                    :class="'w-full'"
                />
            </div>
            <div>
                <label>{{ $translate('public.shop.cart.quantity') }}</label>
                <input
                    type="number"
                    v-model="bike.quantity"
                    min="1"
                    @change="
                        bike.quantity = Math.max(1, bike.quantity);
                        updateCart(bike, 'bike');
                    "
                />
            </div>
            <div class="text-center md:text-right col-span-2">
                <div
                    v-if="bike.promotion == 0 || bike.promotion == null"
                    class="text-xl"
                >
                    <del v-if="bike.portfolio_value">{{
                        formatPrice(bike.portfolio_value * bike.quantity)
                    }}</del>
                    <div class="font-bold">
                        {{ formatPrice(bike.price_tvac * bike.quantity) }}
                    </div>
                </div>
                <div v-else class="text-xl">
                    <del class="del-price">{{
                        formatPrice(bike.price_tvac)
                    }}</del>
                    <div class="font-bold">
                        {{
                            formatPrice(
                                bike.price_tvac -
                                    (bike.price_tvac * bike.promotion) / 100,
                            )
                        }}
                    </div>
                </div>
                <primary-button
                    danger
                    class="mt-2 font-bold"
                    @click="removeFromCart(bike, 'bike')"
                >
                    <i class="fa-regular fa-circle-xmark mr-2"></i>
                    {{ $translate('public.shop.cart.delete') }}
                </primary-button>
            </div>
        </div>
        <div
            v-for="accessory in cart.accessories"
            :key="accessory"
            class="grid grid-cols-2 lg:grid-cols-6 gap-4 items-center border-2 rounded-lg shadow-md mr-2 p-2"
        >
            <div class="col-span-2">
                <p class="font-bold text-center">
                    {{ accessory.brand + ' ' + accessory.model }}
                </p>
                <div class="aspect-[1.777]">
                    <img
                        class="remove_bg_color w-full"
                        :src="
                            $apiUrl() +
                            '/storage/assets/images/accessories_pictures/' +
                            accessory.id +
                            '/A.jpg'
                        "
                        @error="
                            e =>
                                (e.target.src =
                                    '/storage/assets/images/default.png')
                        "
                    />
                </div>
            </div>
            <div>
                <label> Taille : </label>
                <AppSelect
                    v-model="accessory.selected_size"
                    :options="
                        accessory.sizes.map(size => ({
                            label:
                                size +
                                (accessory.stocks[size]
                                    ? ''
                                    : ' - Not Available'),
                            value: size,
                            disabled: !accessory.stocks[size],
                        }))
                    "
                    optionLabel="label"
                    optionValue="value"
                    :disabled="false"
                    @change="updateCart(accessory, 'accessory')"
                    :class="'w-full'"
                />
            </div>
            <div>
                <label>{{ $translate('public.shop.cart.quantity') }}</label>
                <input
                    type="number"
                    v-model="accessory.quantity"
                    min="1"
                    @change="
                        accessory.quantity = Math.max(1, accessory.quantity);
                        updateCart(accessory, 'bike');
                    "
                />
            </div>
            <div class="text-center md:text-right col-span-2">
                <div
                    v-if="accessory.discount == 0 || accessory.discount == null"
                >
                    <del v-if="accessory.portfolio_value">{{
                        formatPrice(
                            accessory.portfolio_value * accessory.quantity,
                        )
                    }}</del>
                    <div class="font-bold text-xl">
                        {{
                            formatPrice(
                                accessory.price_tvac * accessory.quantity,
                            )
                        }}
                    </div>
                </div>
                <div v-else class="promo-container">
                    <del class="del-price">{{
                        formatPrice(accessory.price_tvac)
                    }}</del>
                    <div class="font-bold text-xl">
                        {{
                            formatPrice(
                                accessory.price_tvac -
                                    (accessory.price_tvac *
                                        accessory.discount) /
                                        100,
                            )
                        }}
                    </div>
                </div>
                <primary-button
                    danger
                    class="text-red mt-2 font-bold"
                    @click="removeFromCart(accessory, 'accessory')"
                >
                    <i class="fa-regular fa-circle-xmark mr-2"></i>
                    {{ $translate('public.shop.cart.delete') }}
                </primary-button>
            </div>
        </div>

        <div class="font-bold text-right text-xl mt-4" v-if="!hideButtons">
            <p>{{ $translate('public.shop.cart.total') }}</p>
            <span>{{ formatPrice(cart.totalTvac) }}</span>
        </div>

        <div
            class="flex flex-col md:flex-row justify-end gap-2 mt-4"
            v-if="!hideButtons"
        >
            <primary-button color="red" @click="modalIsOpen = false">
                {{ $translate('public.shop.cart.buttons.1') }}
            </primary-button>
            <primary-button @click="$router.push({ name: 'cart' })">
                {{ $translate('public.shop.cart.buttons.2') }}
            </primary-button>
        </div>
    </div>
</template>
<script setup>
import formatPrice from '@/js/functions/formatPrice.js';
import { useApiStore } from '@/js/stores/apiStore';
import { useCookieStore } from '@/js/stores/cookiesStore';
import { ref } from 'vue';

defineProps({
    hideButtons: Boolean,
});

const emit = defineEmits(['cartUpdated']);

const apiStore = useApiStore();

const cart = ref({});

const addToCart = (type, item, size) => {
    apiStore
        .call('POST', '/api/cart/add', {
            itemId: item.id ?? item.bikes_id,
            type: type,
            selectedSize: size,
            quantity: item.quantity,
        })
        .then(getCart)
        .catch(console.error);
};

const updateCart = (item, type) => {
    apiStore
        .call('POST', '/api/cart/update', {
            itemId: item.id ?? item.bikes_id,
            type,
            selectedSize: item.selected_size,
            quantity: item.quantity,
        })
        .then(getCart)
        .catch(console.error);
};

const removeFromCart = (item, type) => {
    apiStore
        .call('POST', '/api/cart/remove', {
            itemId: item.id ?? item.bikes_id,
            type,
            selectedSize: item.selected_size,
        })
        .then(getCart)
        .catch(console.error);
};

const getCart = () => {
    apiStore
        .call('GET', '/api/cart')
        .then(response => {
            cart.value = response;
            useCookieStore().setCartCount(
                cart.value.bikes.length + cart.value.accessories.length,
            );
            emit('cartUpdated', cart.value);
        })
        .catch(console.error);
};

defineExpose({ getCart, addToCart });
getCart();
</script>
